export const SCHEDULE_TYPE_OPTIONS = [
  {
    label: '固定時間',
    value: 'fixedTime',
  },
  {
    label: '非固定時間',
    value: 'nonFixedTime',
  },
];
